(function () {
  function initArticleEnhancements() {
    var body = document.querySelector('[data-article-body]');
    if (!body) return;

    buildTOC(body);
    insertMidArticleCTA(body);
    wrapFAQ(body);
    initMobileStickyCTA();
    initProgressBar(body);
  }

  function buildTOC(body) {
    var headings = body.querySelectorAll('h2');
    var desktopNav = document.querySelector('[data-article-toc]');
    var mobileNav = document.querySelector('[data-article-toc-mobile]');
    if (!headings.length || !desktopNav) return;

    headings.forEach(function (heading, index) {
      if (!heading.id) {
        heading.id = 'section-' + index;
      }
      var link = document.createElement('a');
      link.href = '#' + heading.id;
      link.textContent = heading.textContent;
      desktopNav.appendChild(link);

      if (mobileNav) {
        mobileNav.appendChild(link.cloneNode(true));
      }
    });

    var links = desktopNav.querySelectorAll('a');
    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            links.forEach(function (link) {
              link.classList.remove('is-active');
              if (link.getAttribute('href') === '#' + entry.target.id) {
                link.classList.add('is-active');
              }
            });
          }
        });
      }, { rootMargin: '-20% 0px -70% 0px' });

      headings.forEach(function (heading) {
        observer.observe(heading);
      });
    }
  }

  function wrapFAQ(body) {
    var headings = Array.prototype.slice.call(body.querySelectorAll('h2'));
    var faqHeading = null;
    for (var i = 0; i < headings.length; i++) {
      var text = headings[i].textContent.toLowerCase();
      if (text.indexOf('veelgestelde vragen') !== -1 || text.indexOf('frequently asked questions') !== -1) {
        faqHeading = headings[i];
        break;
      }
    }
    if (!faqHeading) return;

    var container = document.createElement('div');
    container.className = 'article-faq';

    var node = faqHeading.nextElementSibling;
    var nodesToRemove = [];

    while (node && node.tagName === 'H3') {
      var question = node;
      var answerParts = [];
      var next = node.nextElementSibling;
      nodesToRemove.push(question);

      while (next && next.tagName !== 'H3' && next.tagName !== 'H2') {
        answerParts.push(next);
        nodesToRemove.push(next);
        next = next.nextElementSibling;
      }

      appendFaqItem(container, question, answerParts);

      node = next;
    }

    faqHeading.parentNode.insertBefore(container, faqHeading.nextSibling);
    nodesToRemove.forEach(function (n) {
      if (n.parentNode) n.parentNode.removeChild(n);
    });
  }

  function appendFaqItem(container, question, answerParts) {
    var item = document.createElement('div');
    item.className = 'article-faq__item';

    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'article-faq__question';
    button.innerHTML = '<span>' + question.textContent + '</span><span class="article-faq__icon">+</span>';

    var answer = document.createElement('div');
    answer.className = 'article-faq__answer';
    answerParts.forEach(function (part) {
      answer.appendChild(part.cloneNode(true));
    });

    button.addEventListener('click', function () {
      item.classList.toggle('is-open');
    });

    item.appendChild(button);
    item.appendChild(answer);
    container.appendChild(item);
  }

  function insertMidArticleCTA(body) {
    var wrapper = document.querySelector('.article-enhanced');
    if (!wrapper || wrapper.dataset.scanCta !== 'true') return;

    var headings = Array.prototype.slice.call(body.querySelectorAll('h2'));
    var contentHeadings = headings.filter(function (h) {
      var text = h.textContent.toLowerCase();
      return text.indexOf('veelgestelde vragen') === -1 && text.indexOf('frequently asked questions') === -1;
    });
    if (contentHeadings.length < 2) return;

    var targetHeading = contentHeadings[Math.floor(contentHeadings.length / 2)];

    var cta = document.createElement('div');
    cta.className = 'article-inline-cta';
    cta.innerHTML =
      '<p class="article-inline-cta__text">Benieuwd in welk stadium je zit?</p>' +
      '<a href="https://hairbornproducts.nl/pages/gratis-haaruitval-scan" class="article-inline-cta__button">Doe de gratis scan</a>';

    targetHeading.parentNode.insertBefore(cta, targetHeading);
  }

  function initMobileStickyCTA() {
    var ctaBlock = document.querySelector('.article-scan-cta');
    if (!ctaBlock || window.innerWidth >= 990) return;

    var link = ctaBlock.querySelector('.article-scan-cta__button');
    if (!link) return;

    var bar = document.createElement('div');
    bar.className = 'article-mobile-sticky-cta';
    var clone = document.createElement('a');
    clone.href = link.getAttribute('href');
    clone.textContent = link.textContent;
    bar.appendChild(clone);
    document.body.appendChild(bar);
  }

  function initProgressBar() {
    var fill = document.querySelector('[data-article-progress]');
    if (!fill) return;

    function update() {
      var scrollable = document.body.scrollHeight - window.innerHeight;
      var progress = scrollable > 0 ? (window.scrollY / scrollable) * 100 : 0;
      progress = Math.max(0, Math.min(100, progress));
      fill.style.width = progress + '%';
    }

    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initArticleEnhancements);
  } else {
    initArticleEnhancements();
  }
})();
